import React from "react";
import { createPortal } from "react-dom";
import Swal from "sweetalert2";
import CloseIcon from '@mui/icons-material/Close';
import SendIcon from '@mui/icons-material/Send';

const ModalMuestreoGranel = ({
  isOpen,
  onClose,
  muestreoForm,
  setMuestreoForm,
  allAvailableGraneles = [],
  handleSaveMuestreo
}) => {
  if (!isOpen) return null;

  return createPortal(
        <div className="modal-backdrop-custom animate-fadeIn" onClick={() => onClose()}>
          <div className="detail-modal-card animate-fadeIn" onClick={e => e.stopPropagation()} style={{ maxWidth: "780px" }}>
            <div className="detail-modal-header" style={{ background: "linear-gradient(135deg, #4338CA 0%, #6366F1 100%)", color: "white", padding: "16px 22px" }}>
              <div className="detail-modal-title-box">
                <div style={{ display: "flex", gap: "6px", marginBottom: "4px" }}>
                  <span className="badge-modal-tag" style={{ background: "rgba(255,255,255,0.2)", color: "white" }}>SECCIÓN II: GRANEL</span>
                  <span className="badge-modal-tag" style={{ background: "#E0E7FF", color: "#4338CA", fontWeight: 700 }}>EXTRACCIÓN DE MUESTRA</span>
                </div>
                <h1 className="detail-modal-title" style={{ color: "white", fontSize: "19px" }}>
                  Salida a Muestreo de Mezcal a Granel
                </h1>
              </div>
              <button type="button" onClick={() => onClose()} className="detail-modal-close-btn">
                <CloseIcon />
              </button>
            </div>

            <form onSubmit={(e) => {
              e.preventDefault();
              const vol = parseFloat(muestreoForm.litros_muestra || 0);
              const saldoActual = parseFloat(muestreoForm.volumen_actual || 0);
              if (vol <= 0 || vol > saldoActual) {
                Swal.fire({
                  title: "Volumen inválido",
                  text: `El volumen de muestra debe ser mayor a 0 y no puede exceder el saldo disponible (${saldoActual} L).`,
                  icon: "warning",
                  confirmButtonColor: "#4F46E5"
                });
                return;
              }

              const vRestante = Math.max(0, parseFloat((saldoActual - vol).toFixed(2)));

              if (handleSaveMuestreo) {
                const selectedG = (allAvailableGraneles || []).find(item =>
                  String(item.id_bitacora_granel) === String(muestreoForm.id_granel_origen) ||
                  String(item.id) === String(muestreoForm.id_granel_origen) ||
                  String(item.dbId) === String(muestreoForm.id_granel_origen) ||
                  String(item.noLote || item.no_lote) === String(muestreoForm.id_granel_origen) ||
                  String(item._optVal) === String(muestreoForm.id_granel_origen)
                );
                const realId = selectedG?.id_bitacora_granel ||
                  (typeof selectedG?.id === 'number' ? selectedG.id : null) ||
                  (typeof selectedG?.dbId === 'number' ? selectedG.dbId : null) ||
                  (parseInt(String(muestreoForm.id_granel_origen || selectedG?.id || '').replace(/[^\d]/g, ''), 10) || null) ||
                  muestreoForm.id_granel_origen;

                handleSaveMuestreo({
                  ...muestreoForm,
                  id_granel: realId,
                  id_granel_origen: realId,
                  no_lote_origen: selectedG?.noLote || selectedG?.no_lote || muestreoForm.no_lote_origen,
                  no_lote: selectedG?.noLote || selectedG?.no_lote || muestreoForm.no_lote_origen,
                  volumen: vol,
                  litros_muestra: vol,
                  saldo_restante: vRestante
                });
              }

              onClose();
              Swal.fire({
                title: "¡Solicitud de Muestreo Enviada a la Unidad de Inspección!",
                html: `Se registró la extracción de muestra de <b>${vol} L</b> del lote <b>${muestreoForm.no_lote_origen}</b> para <b>${muestreoForm.tipo_muestreo}</b>.<br/><br/>
                <div style="background: #EEF2FF; border: 1.5px solid #A5B4FC; border-radius: 10px; padding: 12px; text-align: left; font-size: 13px; color: #3730A3; line-height: 1.5;">
                  <div style="margin-bottom: 4px;">• <b>Estatus:</b> Enviado a revisión y validación por la Unidad de Inspección.</div>
                  <div style="margin-bottom: 4px;">• <b>Saldo actual en bitácora:</b> ${saldoActual} L (permanecerá oficial hasta la aprobación del inspector).</div>
                  <div style="margin-bottom: 4px;">• <b>Volumen de muestra:</b> ${vol} L.</div>
                  <div style="margin-bottom: 4px;">• <b>Saldo final proyectado tras aprobación:</b> ${vRestante} L.</div>
                  <div style="margin-bottom: 4px;">• <b>Destino / Tipo:</b> ${muestreoForm.tipo_muestreo}.</div>
                </div>`,
                icon: "success",
                confirmButtonColor: "#4F46E5",
                confirmButtonText: "Entendido"
              });
            }} style={{ padding: "20px 24px", display: "flex", flexDirection: "column", gap: "16px", maxHeight: "80vh", overflowY: "auto" }}>

              {/* Selección de Lote y Saldo */}
              <div style={{ background: "#EEF2FF", border: "1px solid #C7D2FE", borderRadius: "14px", padding: "18px" }}>
                <h4 style={{ margin: "0 0 12px 0", fontSize: "12px", fontWeight: 800, color: "#4338CA", textTransform: "uppercase", letterSpacing: "0.5px" }}>
                  1. Lote a Muestrear y Saldo Disponible
                </h4>
                <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "12px" }}>
                  <div className="integrated-input-box">
                    <span className="integrated-input-label">Lote a Muestrear <span style={{ color: "#DC2626" }}>*</span></span>
                    <select
                      value={muestreoForm.id_granel_origen}
                      onChange={e => {
                        const selId = e.target.value;
                        const g = (allAvailableGraneles || []).find(item =>
                          String(item.id_bitacora_granel) === String(selId) ||
                          String(item.id) === String(selId) ||
                          String(item.dbId) === String(selId) ||
                          String(item.noLote || item.no_lote) === String(selId) ||
                          String(item._optVal) === String(selId)
                        );
                        const v = g ? g._vDisp : 0;
                        setMuestreoForm(prev => ({
                          ...prev,
                          id_granel_origen: selId,
                          no_lote_origen: g?.noLote || g?.no_lote || "",
                          volumen_actual: v
                        }));
                      }}
                      className="integrated-select-control"
                      required
                    >
                      <option value="">-- Seleccionar Lote de Granel ({(allAvailableGraneles || []).filter(g => g._vDisp > 0 || String(g._optVal) === String(muestreoForm.id_granel_origen)).length} Disponibles) --</option>
                      {(allAvailableGraneles || [])
                        .filter(g => g._vDisp > 0 || String(g._optVal) === String(muestreoForm.id_granel_origen))
                        .map((g, idx) => (
                          <option key={g._optVal || idx} value={g._optVal}>
                            {g._label}
                          </option>
                        ))}
                    </select>
                  </div>

                  <div className="integrated-input-box" style={{ background: "#F1F5F9" }}>
                    <span className="integrated-input-label">Saldo Disponible en Tanque</span>
                    <div className="integrated-display-value" style={{ fontWeight: 800, color: "#1E293B" }}>
                      {muestreoForm.volumen_actual ? `${muestreoForm.volumen_actual.toLocaleString()} Litros` : "0 Litros"}
                    </div>
                    <span className="integrated-input-suffix">L</span>
                  </div>
                </div>
              </div>

              {/* Volumen y Destino del Muestreo */}
              <div style={{ background: "#F8FAFC", border: "1px solid #CBD5E1", borderRadius: "14px", padding: "18px" }}>
                <h4 style={{ margin: "0 0 12px 0", fontSize: "12px", fontWeight: 800, color: "#334155", textTransform: "uppercase", letterSpacing: "0.5px" }}>
                  2. Parámetros de la Muestra (NOM-070-SCFI-2016)
                </h4>

                <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "12px", marginBottom: "14px" }}>
                  <div className="integrated-input-box" style={{ borderColor: "#6366F1", background: "#EEF2FF" }}>
                    <span className="integrated-input-label" style={{ color: "#4338CA" }}>Volumen de Muestra (L) <span style={{ color: "#DC2626" }}>*</span></span>
                    <input
                      type="number"
                      step="0.01"
                      min="0.1"
                      max={muestreoForm.volumen_actual || undefined}
                      placeholder="Ej: 1.5, 3.0"
                      value={muestreoForm.litros_muestra}
                      onChange={e => setMuestreoForm(prev => ({ ...prev, litros_muestra: e.target.value }))}
                      className="integrated-input-control"
                      style={{ fontWeight: 900, color: "#4338CA", fontSize: "15px" }}
                      required
                    />
                    <span className="integrated-input-suffix" style={{ color: "#4338CA", background: "#E0E7FF", borderColor: "#C7D2FE" }}>L</span>
                  </div>

                  <div className="integrated-input-box">
                    <span className="integrated-input-label">Tipo / Destino de Muestreo <span style={{ color: "#DC2626" }}>*</span></span>
                    <select
                      value={muestreoForm.tipo_muestreo}
                      onChange={e => setMuestreoForm(prev => ({ ...prev, tipo_muestreo: e.target.value }))}
                      className="integrated-select-control"
                      required
                    >
                      <option value="Muestreo Oficial NOM-070 (Tercio de muestra: ensayo, testigo socio, testigo UI)">Muestreo Oficial NOM-070 (Tercio de muestra: ensayo, testigo socio, testigo UI)</option>
                      <option value="Muestreo para Análisis Fisicoquímico Previo (Laboratorio Acreditado)">Muestreo para Análisis Fisicoquímico Previo (Laboratorio Acreditado)</option>
                      <option value="Muestreo de Calidad Interno / Perfil Organoléptico">Muestreo de Calidad Interno / Perfil Organoléptico</option>
                      <option value="Muestra Comercial / Exportación / Envío a Cliente">Muestra Comercial / Exportación / Envío a Cliente</option>
                    </select>
                  </div>
                </div>

                {/* Tarjeta de Cálculo de Saldo Resultante */}
                {(() => {
                  const vol = parseFloat(muestreoForm.litros_muestra || 0);
                  const saldoActual = parseFloat(muestreoForm.volumen_actual || 0);
                  const vRestante = Math.max(0, parseFloat((saldoActual - vol).toFixed(2)));
                  return (
                    <div style={{ background: "linear-gradient(135deg, #EEF2FF 0%, #E0E7FF 100%)", border: "1.5px solid #A5B4FC", borderRadius: "12px", padding: "14px 18px", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                      <div>
                        <span style={{ fontSize: "11px", fontWeight: 800, color: "#4338CA", textTransform: "uppercase", letterSpacing: "0.5px" }}>Muestra a Extraer:</span>
                        <div style={{ fontSize: "20px", fontWeight: 900, color: "#4F46E5" }}>
                          -{vol.toLocaleString()} Litros
                        </div>
                      </div>
                      <div style={{ textAlign: "right" }}>
                        <span style={{ fontSize: "11px", fontWeight: 800, color: "#4338CA", textTransform: "uppercase", letterSpacing: "0.5px" }}>Saldo Final Proyectado tras Dictamen UI:</span>
                        <div style={{ fontSize: "20px", fontWeight: 900, color: "#166534" }}>
                          {vRestante.toLocaleString()} Litros
                        </div>
                      </div>
                    </div>
                  );
                })()}
              </div>

              {/* Laboratorio y Folio */}
              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "12px" }}>
                <div className="integrated-input-box">
                  <span className="integrated-input-label">Laboratorio Acreditado o Inspector Asignado</span>
                  <input
                    type="text"
                    placeholder="Ej: Laboratorio CIATEJ, Ing. Carlos Mendoza"
                    value={muestreoForm.laboratorio_inspector}
                    onChange={e => setMuestreoForm(prev => ({ ...prev, laboratorio_inspector: e.target.value }))}
                    className="integrated-input-control"
                  />
                </div>

                <div className="integrated-input-box">
                  <span className="integrated-input-label">No. Solicitud / Precinto / Acta de Muestreo</span>
                  <input
                    type="text"
                    placeholder="Ej: SOL-MUES-2026-44, PRECINTOS 89-91"
                    value={muestreoForm.folio_documento}
                    onChange={e => setMuestreoForm(prev => ({ ...prev, folio_documento: e.target.value }))}
                    className="integrated-input-control"
                  />
                </div>
              </div>

              {/* Fecha y Observaciones */}
              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "12px" }}>
                <div className="integrated-input-box">
                  <span className="integrated-input-label">Fecha de Muestreo <span style={{ color: "#DC2626" }}>*</span></span>
                  <input
                    type="date"
                    value={muestreoForm.fecha}
                    onChange={e => setMuestreoForm(prev => ({ ...prev, fecha: e.target.value }))}
                    className="integrated-input-control"
                    required
                  />
                </div>

                <div className="integrated-input-box">
                  <span className="integrated-input-label">Observaciones de Precintos y Condiciones</span>
                  <input
                    type="text"
                    placeholder="Notas sobre precintos, temperatura o condiciones..."
                    value={muestreoForm.observaciones}
                    onChange={e => setMuestreoForm(prev => ({ ...prev, observaciones: e.target.value }))}
                    className="integrated-input-control"
                  />
                </div>
              </div>

              {/* Aviso de Validación UI */}
              <div style={{ background: "#EEF2FF", border: "1.5px solid #A5B4FC", borderRadius: "12px", padding: "12px 16px", display: "flex", flexDirection: "column", gap: "6px" }}>
                <div style={{ display: "flex", alignItems: "center", gap: "8px", color: "#4338CA", fontWeight: 800, fontSize: "12.5px" }}>
                  <span>📋</span>
                  <span>FLUJO DE VALIDACIÓN OBLIGATORIA POR LA UNIDAD DE INSPECCIÓN (UI)</span>
                </div>
                <p style={{ margin: 0, fontSize: "12px", color: "#312E81", lineHeight: 1.4 }}>
                  Al registrar este muestreo, se generará la solicitud y pasará a <strong>revisión y dictamen del Inspector de la UI</strong>. El volumen de muestra de <strong>{parseFloat(muestreoForm.litros_muestra || 0)} L</strong> se descontará oficialmente del inventario de forma automática una vez que el Inspector emita su aprobación.
                </p>
              </div>

              <div style={{ display: "flex", justifyContent: "flex-end", gap: "10px", marginTop: "10px" }}>
                <button
                  type="button"
                  onClick={() => onClose()}
                  className="btn-cancel-custom"
                  style={{ padding: "10px 18px", borderRadius: "10px", border: "1px solid #CBD5E1", background: "white", fontWeight: 600 }}
                >
                  Cancelar
                </button>
                <button
                  type="submit"
                  style={{
                    background: "linear-gradient(135deg, #4338CA 0%, #6366F1 100%)",
                    color: "white",
                    border: "none",
                    borderRadius: "10px",
                    padding: "10px 22px",
                    fontWeight: 700,
                    cursor: "pointer",
                    boxShadow: "0 4px 14px rgba(99, 102, 241, 0.3)",
                    display: "inline-flex",
                    alignItems: "center",
                    gap: "8px"
                  }}
                >
                  <SendIcon style={{ fontSize: 18 }} />
                  <span>Enviar Solicitud de Muestreo a UI</span>
                </button>
              </div>
            </form>
          </div>
        </div>,
        document.body
,
    document.body
  );
};

export default ModalMuestreoGranel;
